export default {
  methods: {
    testPlugin() {
      console.log("testPlugin")
    }
  }
}
